<template>
  <aside class="draft-banner" role="status">
    <DraftBadge />
    <div><strong>Draft Preview</strong><p>This content is visible only to authorized Reckon users while Draft Mode is on.</p></div>
  </aside>
</template>

<script>
import DraftBadge from './DraftBadge.vue';

export default { name: 'DraftBanner', components: { DraftBadge } };
</script>

<style scoped>
.draft-banner { align-items: center; background: rgba(240,177,60,.1); border: 1px solid rgba(240,177,60,.65); border-radius: 10px; color: #fff; display: flex; gap: 14px; margin: 0 0 28px; padding: 14px 16px; }
.draft-banner strong { font-family: "Oswald", sans-serif; font-size: 1rem; text-transform: uppercase; }
.draft-banner p { color: #d7c39e; font-size: .85rem; margin: 2px 0 0; }
@media (max-width: 600px) { .draft-banner { align-items: flex-start; } }
</style>
